__turbopack_context__.v({
  "root": "icon-button-module-scss-module__KjU5_q__root",
});
